import React from 'react'
import { PulseLoader } from 'react-spinners'
import { OverlayLoading } from '~/components/mapContent/styles/overlayLoading'

interface FullscreenLoaderProps {
  isActive: boolean
  message?: string
}

export function FullscreenLoader({
  isActive,
  message = 'Carregando...',
}: FullscreenLoaderProps) {
  if (!isActive) return null

  return (
    <OverlayLoading>
      <div className='center'>
        <PulseLoader color='#fff' />
        <div className='message'>{message}</div>
      </div>
    </OverlayLoading>
  )
}
